import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from '@material-ui/core';
import { TextField } from 'formik-material-ui';
import { makeStyles } from '@material-ui/core/styles';
import { getNationalityListOptions } from '../../../constants/countryList';

const useInputStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: theme.custom.inputs.maxWidth,
    marginBottom: theme.spacing(5),
  },
}));

const InputNationalityCountry = ({ hint, required, label, ...props }) => {
  const classes = useInputStyles();
  const optionElements = getNationalityListOptions().map((option) => (
    <MenuItem key={option.key} value={option.key}>
      {option.label}
    </MenuItem>
  ));
  return (
    <TextField
      {...props}
      size="small"
      label={label}
      required={required}
      helperText={hint}
      select
      variant="outlined"
      className={classes.root}
      color="primary"
    >
      {optionElements}
    </TextField>
  );
};

InputNationalityCountry.propTypes = {
  required: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  hint: PropTypes.string,
};

InputNationalityCountry.defaultProps = {
  hint: null,
};

export default InputNationalityCountry;
